import { Injectable } from '@angular/core';
import { commonFunctionService } from "../utils/commonFunctions";
import { apiConstants } from "../constant/apiConstant";
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/config/config';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CheckinCheckoutReportService {
private URL_V3 = AppSettings.API_ENDPOINT_V3;
  constructor(private http: HttpClient,private commonFunction: commonFunctionService) { }
  getWingData(){
      const headers = this.commonFunction.appendHeader(); 
      return this.http.get(this.URL_V3 + `${apiConstants.getWingData}/?lang=en`, { headers }).pipe(map(res => res));
    }
    getClassStandardList(wingId){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getClassStandardList}/?lang=en&classCategoryId=${wingId}`, { headers }).pipe(map(res => res));
  }
  getClassStandardListData(body){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.post(this.URL_V3 + `${apiConstants.getClassStandardListInfo}` ,body,{ headers }).pipe(map(res => res));
  }
  getClassSectionData(wingId,classStandardId){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.get(this.URL_V3 + `${apiConstants.getClassSectionData}/?lang=en&classCategoryId=${wingId}&classStandardId=${classStandardId}`, { headers }).pipe(map(res => res));
  }
    getClassSectionDataInfo(body){
    const headers = this.commonFunction.appendHeader(); 
    return this.http.post(this.URL_V3 + `${apiConstants.getClassSectionDataInfo}`,body, { headers }).pipe(map(res => res));
  }
  getStudentListInfo(body: any) {
  const headers = this.commonFunction.appendHeader();
  return this.http.post(this.URL_V3 + `${apiConstants.getcheckinCheckoutsearch}`, body, { headers }).pipe(map(res => res));
}
getCheckinCheckoutReport(body: any) {
  const headers = this.commonFunction.appendHeader();
  return this.http.post(
    this.URL_V3 + `${apiConstants.getCheckinCheckoutStats}`, body, { headers }).pipe(map(res => res));
} 
getCheckinCheckoutReportData(body: any) {
  const headers = this.commonFunction.appendHeader();
  return this.http.post(
    this.URL_V3 + `${apiConstants.getCheckinCheckoutTableData}`,body,{ headers }).pipe(map(res => res));
}
getcheckinCheckoutExport(body: any) {
  const headers = this.commonFunction.appendHeader();
  return this.http.post(
    this.URL_V3 + `${apiConstants.getcheckinCheckoutExportReport}`,body,{ headers , responseType: 'blob' as 'json' }).pipe(map(res => res));
}
}
